"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    desc: "<p>\n    \u041E\u0431\u0443\u0432\u044C \u0441 \u043E\u0440\u0438\u0433\u0438\u043D\u0430\u043B\u044C\u043D\u044B\u043C \u043F\u0440\u0438\u043D\u0442\u043E\u043C \u0443\u043A\u0440\u0430\u0441\u0438\u0442 \u0432\u0430\u0448 \u0433\u0430\u0440\u0434\u0435\u0440\u043E\u0431.\n  </p>",
};
